function initCookieCheck() {
    var checkOnLoad = ['tracking_nonce'];

    var pantVars = window._pants = window._pants || {};
    var cookies;
    if (!pantVars.cookies) {
        cookies = pantVars.cookies = Cookies.noConflict();
    }

    for (var i = 0; checkOnLoad.length > i; i++) {
        var cookieCheckData = cookieGet(checkOnLoad[i]);
        if (cookieCheckData) {
            switch (checkOnLoad[i]) {
                case 'tracking_nonce':
                    trackingCallback(cookieCheckData);
                    cookies.remove('tracking_nonce');
                    break;
                default:
            }
        }
    }
}

function cookieSet(name, value, time) {
    var jsonStr = JSON.stringify(value);
    var base64data = btoa(jsonStr);
    window._pants.cookies.set(name, base64data, time);
}

function cookieGet(name) {
    var cookie = window._pants.cookies.get(name);

    if (cookie) {
        return cookie;
    }
    else {
        return false;
    }
}

function trackingCallback(data) {
    var jsonStr = atob(data), jsonObj;
    var me = this;
    try {
        jsonObj = JSON.parse(jsonStr);
    } catch (e) {
        jsonObj = false;
        console.log('cookie json invalid')
    }

    if (jsonObj && jsonObj.fn.length && jsonObj.args.length) {
        console.log('cookieHit', jsonObj);
        if (isFunction(window[jsonObj.fn])) {
            window[jsonObj.fn].apply(me, jsonObj.args);
        }

    }
}

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}